import { SPROUT_AGENT } from '@fruitful/llm-service-shared';
import { Stack, useLocalSearchParams } from 'expo-router';
import React from 'react';

import { DatasetPage } from '../../../../llm-service/datasets/DatasetPage';

const readAgentId = (agentId: string | string[] | undefined): string => {
    if (typeof agentId === 'string') {
        return agentId;
    }
    return agentId?.[0] ?? '';
};

export default function DatasetRoute() {
    const { agentId } = useLocalSearchParams<{ agentId: string }>();
    const id = readAgentId(agentId);

    return (
        <>
            <Stack.Screen
                options={{
                    title:
                        id === SPROUT_AGENT.id ? 'Sprout dataset' : 'Dataset',
                }}
            />
            <DatasetPage agentId={id} />
        </>
    );
}
